import { Api } from "./Api";
import _ from "lodash";
import axios from "axios";
import { RecurrenceIntervention } from "../models/RecurrenceIntervention";
import moment from "moment";
import Remplacement = RecurrenceIntervention.Remplacement;

export class RecurrenceInterventionApi extends Api {
    constructor() {
        super("recurrence_intervention");
    }

    getAll(params?: Object): Promise<Api.CallResponse> {
        return this.getResources(params).then(function (response) {
            var res: Array<RecurrenceIntervention> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (d) {
                    return new RecurrenceIntervention(d);
                });
            }
            return {
                data: res,
                metadata: response.data.metadata,
                paginator: response.data.paginator,
            };
        });
    }

    get(id: Number, params?: Object): Promise<RecurrenceIntervention> {
        return this.getResource(id, params).then(function (response) {
            return new RecurrenceIntervention(response.data.data);
        });
    }

    save(
        recurrence_intervention: RecurrenceIntervention
    ): Promise<RecurrenceIntervention> {
        return super
            .saveResource(recurrence_intervention.serialize())
            .then(function (response) {
                return new RecurrenceIntervention(response.data.data);
            });
    }

    /**
     * Archive ou restaure une récurrence. Seul le champ archived est envoyé :
     * la liste charge les récurrences sans leurs interventions secondaires,
     * un enregistrement complet les effacerait.
     */
    setArchived(id: Number, archived: boolean): Promise<RecurrenceIntervention> {
        return super
            .updateResource(id, { archived: archived })
            .then(function (response) {
                return new RecurrenceIntervention(response.data.data);
            });
    }

    remove(id: Number, raison: string): Promise<RecurrenceIntervention> {
        return super.deleteResource(id, raison).then(function (response) {
            return new RecurrenceIntervention(response.data.data);
        });
    }

    resetInterventionRecurrente(
        recurrence_intervention_id: number,
        date: string
    ) {
        let params: any = {};

        let dateObj = moment(date, "DD/MM/YYYY");

        if (dateObj.isValid()) {
            params.date = dateObj.format("YYYY-MM-DD");
        }

        return axios.get(this.apiUrl + recurrence_intervention_id + "/reset", {
            params: params,
        });
    }

    // Fréquences
    addFrequence(
        recurrence_intervention_id: number,
        frequence: RecurrenceIntervention.Frequence
    ): Promise<RecurrenceIntervention.Frequence> {
        return axios
            .post(
                this.apiUrl + recurrence_intervention_id + "/frequence",
                frequence.serialize()
            )
            .then(function (response) {
                return new RecurrenceIntervention.Frequence(response.data.data);
            });
    }

    updateFrequence(
        recurrence_intervention_id: number,
        frequence: RecurrenceIntervention.Frequence
    ): Promise<RecurrenceIntervention.Frequence> {
        return axios
            .put(
                this.apiUrl +
                    recurrence_intervention_id +
                    "/frequence/" +
                    frequence.id,
                frequence.serialize()
            )
            .then(function (response) {
                return new RecurrenceIntervention.Frequence(response.data.data);
            });
    }

    removeFrequence(
        recurrence_intervention_id: number,
        frequence_id: number
    ): Promise<RecurrenceIntervention.Frequence> {
        return axios
            .delete(
                this.apiUrl +
                    recurrence_intervention_id +
                    "/frequence/" +
                    frequence_id
            )
            .then(function (response) {
                return new RecurrenceIntervention.Frequence(response.data.data);
            });
    }

    // Remplacements

    getRemplacement(
        recurrence_intervention_id: number,
        remplacement_id: number,
        params?: Object
    ): Promise<RecurrenceIntervention.Remplacement> {
        return axios
            .get(
                this.apiUrl +
                    recurrence_intervention_id +
                    "/remplacement/" +
                    remplacement_id,
                { params: params }
            )
            .then(function (response) {
                return new RecurrenceIntervention.Remplacement(
                    response.data.data
                );
            });
    }
    addRemplacement(
        remplacement: RecurrenceIntervention.Remplacement
    ): Promise<RecurrenceIntervention.Remplacement> {
        return axios
            .post(this.apiUrl + "remplacement", remplacement.serialize())
            .then(function (response) {
                return new RecurrenceIntervention.Remplacement(
                    response.data.data
                );
            });
    }

    updateRemplacement(
        remplacement: RecurrenceIntervention.Remplacement
    ): Promise<RecurrenceIntervention.Remplacement> {
        return axios
            .put(
                this.apiUrl + "remplacement/" + remplacement.id,
                remplacement.serialize()
            )
            .then(function (response) {
                return new RecurrenceIntervention.Remplacement(
                    response.data.data
                );
            });
    }

    saveRemplacement(
        remplacement: RecurrenceIntervention.Remplacement
    ): Promise<RecurrenceIntervention.Remplacement> {
        if (remplacement.id) {
            return this.updateRemplacement(remplacement);
        } else {
            return this.addRemplacement(remplacement);
        }
    }

    removeRemplacement(
        remplacement_id: number
    ): Promise<RecurrenceIntervention.Remplacement> {
        return axios
            .delete(this.apiUrl + "remplacement/" + remplacement_id)
            .then(function (response) {
                return new RecurrenceIntervention.Remplacement(
                    response.data.data
                );
            });
    }

    // Alertes
    getAlerts() {
        return axios
            .get(this.apiUrl + "remplacement/alert", {
                params: { include: "recurrence_interventions" },
            })
            .then(function (response) {
                var res: Array<Remplacement> = [];
                if (response.data) {
                    res = _.map(response.data, function (r) {
                        return new Remplacement(r);
                    });
                }
                return res;
            });
    }
}
